exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._18x6o{position:absolute;bottom:0;display:inline-block;opacity:0;visibility:hidden;padding:6px;z-index:59}.GBLNy{opacity:1;visibility:visible;z-index:59}._19PRf{opacity:0;visibility:hidden;z-index:58}.animated ._18x6o{transition-property:left,right,top,bottom,opacity,visibility;transition-duration:1s}._1cvjA{display:none;width:10px;height:10px;position:absolute;top:12px;right:12px;cursor:pointer;opacity:.8}._1cvjA:hover{opacity:.6}._18x6o:hover ._1cvjA{display:block}[data-playable-hook=player-container][min-width~=\"901px\"] ._1cvjA{top:16px;right:16px}.preview-mode ._1cvjA{opacity:.6;cursor:default}.preview-mode ._1cvjA:hover{opacity:.6}", ""]);

// exports
exports.locals = {
	"container": "_18x6o",
	"visible": "GBLNy",
	"hidden": "_19PRf",
	"close-button": "_1cvjA",
	"closeButton": "_1cvjA"
};